import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BorrowerHeaderSmartComponent } from './borrower-header-smart/borrower-header-smart.component';
import { ApplicationCompleteStatusModule } from './application-complete-status/application-complete-status.module';
import { BorrowerPackageReadyStatusModule } from './borrower-package-ready-status/borrower-package-ready-status.module';
import { BorrowerOnlineStatusModule } from './borrower-online-status/borrower-online-status.module';
import { ShareAssignmentDetailsModule } from './share-assignment-details/share-assignment-details.module';
import { BorrowerStatusDisplayModule } from './borrower-status-display/borrower-status-display.module';
import { BorrowerNameModule } from './borrower-name/borrower-name.module';
import { BorrowerFlagsModule } from './borrower-flags/borrower-flags.module';
import { DuplicateBorrowerModule } from './duplicate-borrower/duplicate-borrower.module';
import { QuickInfoModule } from './quick-info/quick-info.module';
import { NotesModule } from 'app/notes/notes.module';
import { BorrowerContactModule } from './borrower-contact/borrower-contact.module';
import { ErcLinkedBusinessModule } from './erc-linked-business/erc-linked-business.module';
import {
  BorrowerDoingBusinessAsNameModule
} from './borrower-doing-business-as-name/borrower-doing-business-as-name.module';
import { PartnerRestrictionModule } from 'app/partner-restriction/partner-restriction.module';
import { BorrowerAlertsModule } from 'app/borrower-alerts/borrower-alerts.module';
import { MatCardModule } from '@angular/material/card';
import { BorrowerActionsModule } from './borrower-actions/borrower-actions.module';
import { CallButtonModule } from './call-button/call-button.module';
import { FormsModule } from '@angular/forms';
import { CompleteAppSmartModule } from './complete-app-smart/complete-app-smart.module';
import { BorrowerComplaintModule } from './borrower-complaint/borrower-complaint.module';
import { MatChipsModule } from '@angular/material/chips';
import { ScaryDirective } from 'ng2-app/directives/scary.directive';

@NgModule( {
  declarations: [
    BorrowerHeaderSmartComponent,
  ],
  providers: [
    TitleCasePipe
  ],
  imports: [
    ApplicationCompleteStatusModule,
    BorrowerPackageReadyStatusModule,
    BorrowerActionsModule,
    BorrowerAlertsModule,
    BorrowerComplaintModule,
    BorrowerContactModule,
    BorrowerDoingBusinessAsNameModule,
    BorrowerFlagsModule,
    BorrowerNameModule,
    BorrowerOnlineStatusModule,
    BorrowerStatusDisplayModule,
    CallButtonModule,
    CommonModule,
    CompleteAppSmartModule,
    DuplicateBorrowerModule,
    ErcLinkedBusinessModule,
    FormsModule,
    MatCardModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule,
    NotesModule,
    PartnerRestrictionModule,
    QuickInfoModule,
    ShareAssignmentDetailsModule,
    ScaryDirective,
  ],
  exports: [
    BorrowerHeaderSmartComponent,
  ]
} )
export class BorrowerHeaderModule {
}
